<template>
    <div class="organization-selector-nav">
        <b-nav-item-dropdown
            id="dropdown-grouped"
            variant="link"
            right
            v-if="isVisible"
        >
            <template #button-content>
                <span class="ml-50 text-body">{{ organization.title }}</span>
            </template>
            <vue-perfect-scrollbar
                ref="organization-selector"
                :settings="{maxScrollbarLength: 200}"
                class="scroll-area"
            >
                <b-dropdown-item
                    v-for="org in organizations"
                    :key="org.id"
                    @click="select(org)"
                >
                    <span class="ml-50">{{ org.title }}</span>
                </b-dropdown-item>
            </vue-perfect-scrollbar>
        </b-nav-item-dropdown>
        <span v-else class="ml-50 text-body" style="color: #fff !important;">{{ organization.title }}</span>
    </div>
</template>
<script>
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components: {
        BNavItemDropdown, BDropdownItem, VuePerfectScrollbar,
    },

    methods: {
        select(organization) {
            this.$store.dispatch('selectOrganization', organization).then(() => {
                if (this.$router.currentRoute.name !== 'homepage') {
                    this.$router.replace('/homepage');
                }
            });
        },
    },

    computed: {
        organization() {
            return this.$store.state.user.organization;
        },
        organizations() {
            return this.$store.state.user.organizations;
        },
        isVisible() {
            return this.$store.state.user.organizations.length > 1;
        }
    }
};
</script>

<style lang="scss">
.organization-selector-nav .scroll-area {
    max-height: 560px;
}
</style>
